import { render, staticRenderFns } from "./CellsModule.vue?vue&type=template&id=62fc7d35"
import script from "./CellsModule.vue?vue&type=script&lang=js"
export * from "./CellsModule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports